import { useEffect, useState } from 'react'
import ReactHowler from 'react-howler'
import { NavLink } from 'react-router-dom'
import ReactGA from 'react-ga4'
import { Link } from 'react-router-dom'
export const Navigation = () => {
    const [navbarOpen, setNavbarOpen] = useState(false)
    const [soundOn, setSoundOn] = useState(false)
    const [soundState, setSoundState] = useState(0) // 0: Off, 1: Low Volume, 2: High Volume
    const handleSoundToggle = () => {
        setSoundState((prevState) => (prevState + 1) % 3)
    }

    useEffect(() => {}, [soundState])

    let imageUrl
    switch (soundState) {
        case 0:
            imageUrl = `${process.env.PUBLIC_URL}/images/bgm-off.png`
            break
        case 1:
            imageUrl = `${process.env.PUBLIC_URL}/images/bgm-low.png`
            break
        case 2:
            imageUrl = `${process.env.PUBLIC_URL}/images/bgm-on.png`
            break
        default:
            imageUrl = `${process.env.PUBLIC_URL}/images/bgm-off.png`
    }
    const isPlaying = soundState !== 0
    const volume = soundState === 1 ? 0.1 : 0.6
    return (
        <header className='md:block items-center sticky top-0 z-50 bg-white/20 md:backdrop-blur-sm md:px-4'>
            <div className='mx-auto hidden md:block relative'>
                <div className='relative'>
                    <ul className='px-0 flex max-w-[1200px] mx-auto flex-row justify-between cursor-pointer items-center h-[80px] text-nav-tablet'>
                        <li>
                            <NavLink to='/' end className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                <h1 className='text-center text-gradient-nav font-pop'>Top</h1>{' '}
                            </NavLink>{' '}
                        </li>
                        <li>
                            <NavLink to='story' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                <h1 className='text-center text-gradient-nav font-pop'>Story</h1>{' '}
                            </NavLink>
                        </li>{' '}
                        <li>
                            <span className='relative  inline-block'>
                                <NavLink
                                    to='characters'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <h1 className='newicon text-center text-gradient-nav font-pop'>Characters</h1>{' '}
                                </NavLink>{' '}
                            </span>
                        </li>{' '}
                        <li>
                            <span className='relative  inline-block'>
                                <NavLink to='system' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                    <h1 className='text-center text-gradient-nav font-pop'>System</h1>{' '}
                                </NavLink>
                            </span>
                        </li>
                        <li>
                            {' '}
                            <span className='relative inline-block'>
                                <NavLink to='media' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                    <h1 className='text-center text-gradient-nav font-pop'>Media</h1>{' '}
                                </NavLink>
                            </span>
                        </li>{' '}
                        <li>
                            {' '}
                            <span className='relative newicon-nav inline-block'>
                                <NavLink to='dlc' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                    <h1 className='text-center text-gradient-nav font-pop'>DLC</h1>{' '}
                                </NavLink>
                            </span>
                        </li>
                        <li>
                            {' '}
                           
                            <NavLink to='products' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                <h1 className='text-center text-gradient-nav font-pop'>Products</h1>{' '}
                            </NavLink>{' '}
                        </li>{' '}
                        <li>
                            {' '}
                            <span className='relative newicon-nav inline-block'>
                                <a
                                    href='https://nisamerica.com/phantombrave-the-lost-hero/manual/'
                                    
                                >
                                    <h1 className='text-center text-gradient-nav font-pop'>Manual</h1>
                                </a>
                            </span>
                        </li>{' '}
                        <li>
                            <NavLink to='contest' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                <h1 className='text-center text-gradient-nav font-pop'>Contest</h1>{' '}
                            </NavLink>
                        </li>
                        <button onClick={handleSoundToggle}>
                            <img className='' src={imageUrl} alt='bgm on off button' />
                            <ReactHowler
                                src={`${process.env.PUBLIC_URL}/voice/016_south_island.mp3`}
                                playing={isPlaying}
                                loop={true}
                                volume={volume}
                                onEnd={() => setSoundState(0)}
                            />
                        </button>
                    </ul>
                </div>
            </div>
            {/* mobile navbar */}

            <div className='md:hidden'>
                <div className='fixed top-1 right-1 z-10'>
                    <img
                        className='w-auto max-w-[65px]'
                        src={`${process.env.PUBLIC_URL}/images/bg_close.png`}
                        alt='close'
                    />{' '}
                    <div className='absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-10 p-1'>
                        <button onClick={() => setNavbarOpen(!navbarOpen)} className=''>
                            <img
                                className='w-full hover:brightness-150'
                                src={`${process.env.PUBLIC_URL}/images/btn_open.png`}
                                alt='menu button'
                            />{' '}
                        </button>{' '}
                        <button onClick={handleSoundToggle}>
                            <img className='' src={imageUrl} alt='bgm on off button' />
                            <ReactHowler
                                src={`${process.env.PUBLIC_URL}/voice/016_south_island.mp3`}
                                playing={isPlaying}
                                loop={true}
                                volume={volume}
                                onEnd={() => setSoundState(0)}
                            />
                        </button>
                        <div className='md:hidden block translate-y-[20px]'>
                            <div className='left-1/2 -translate-x-1/2 absolute flex flex-col md:flex-row  items-center  bg-pbyellow border-pbnavy border-3  text-pbnavy font-sans text-subsmall rounded-lg'>
                                <div className='bg-pbnavy text-pbyellow w-full'>
                                    <p className='m-1'>Languages </p>
                                </div>
                                <div className='relative w-full '>
                                    <div className='w-full text-pborange py-1 px-1 text-center'>
                                        <p>English</p>{' '}
                                    </div>
                                </div>
                                <div className='w-full text-pbnavy hover:text-pborange py-1 px-1 text-center'>
                                    <a href='https://nisamerica.com/phantombrave-the-lost-hero-fr'>Français</a>{' '}
                                </div>
                            </div>{' '}
                        </div>
                    </div>
                </div>

                <div
                    onClick={() => setNavbarOpen(!navbarOpen)}
                    className={`ease-in-out duration-500 py-20 top-0 left-0 w-full fixed z-20 lg:hidden  ${
                        navbarOpen
                            ? 'absolute translate-y-0 translate-x-0 bg-white/20 backdrop-blur-md h-screen '
                            : '-translate-y-[800px]'
                    }`}
                >
                    <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 global-menu'>
                        <button onClick={() => setNavbarOpen(!navbarOpen)} className=''>
                            <img
                                className='global-nav-close-button'
                                src={`${process.env.PUBLIC_URL}/images/btn_close.png`}
                                alt='close'
                            />{' '}
                        </button>{' '}
                        <ul className='flex flex-col space-y-4'>
                            <li>
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='/'
                                    end
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <h1 className='text-center text-gradient-nav text-md lg:text-xlg font-pop'>Top</h1>{' '}
                                </NavLink>{' '}
                            </li>
                            <li>
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='story'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <h1 className='text-center text-gradient-nav text-md lg:text-xlg font-pop'>
                                        Story
                                    </h1>{' '}
                                </NavLink>
                            </li>{' '}
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='characters'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <span className='relative'>
                                        <h1 className='text-center text-gradient-nav text-md lg:text-xlg inline-block font-pop'>
                                            Characters
                                        </h1>{' '}
                                    </span>
                                </NavLink>
                            </li>{' '}
                            <li className='w-full text-center'>
                                {' '}
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='system'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <span className='relative'>
                                        <h1 className='text-gradient-nav text-md lg:text-xlg font-pop inline-block text-center'>
                                            System
                                        </h1>
                                    </span>
                                </NavLink>
                            </li>
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='media'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <span className='relative'>
                                        <h1 className='text-gradient-nav text-md lg:text-xlg font-pop inline-block text-center'>
                                            Media
                                        </h1>{' '}
                                    </span>
                                </NavLink>
                            </li>{' '}
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='dlc'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <span className='relative newicon-mobilenav'>
                                        <h1 className='text-gradient-nav text-md lg:text-xlg font-pop inline-block text-center'>
                                            DLC
                                        </h1>{' '}
                                    </span>
                                </NavLink>
                            </li>
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='products'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <h1 className='text-gradient-nav text-md lg:text-xlg font-pop inline-block text-center'>
                                        Products
                                    </h1>
                                </NavLink>
                            </li>{' '}
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='https://nisamerica.com/phantombrave-the-lost-hero/manual/'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <span className='relative  newicon-mobilenav'>
                                        <h1 className='text-gradient-nav text-md lg:text-xlg font-pop inline-block text-center'>
                                            Manual
                                        </h1>
                                    </span>
                                </NavLink>{' '}
                            </li>{' '}
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => setNavbarOpen(!navbarOpen)}
                                    to='contest'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <h1 className='text-gradient-nav text-md lg:text-xlg font-pop inline-block text-center'>
                                        Contest
                                    </h1>{' '}
                                </NavLink>
                            </li>{' '}
                        </ul>{' '}
                    </div>{' '}
                </div>
            </div>
        </header>
    )
}
